import { useCallback } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useCatalogService, PortfolioShare } from '../services/catalogService';

export const sharingStatusKeys = {
  status: (customerId: string, accountId?: string) =>
    ['service-administration', 'sharing-status', customerId, accountId ?? null] as const,
};

export function useSharingStatus(customerId: string, accountId?: string) {
  const catalogService = useCatalogService();

  const query = useQuery({
    queryKey: sharingStatusKeys.status(customerId, accountId),
    queryFn: async () => {
      const result = await catalogService.getSharingStatus(customerId, accountId);
      return result.shares;
    },
    enabled: !!customerId,
  });

  const { refetch } = query;
  const refresh = useCallback(async () => {
    await refetch();
  }, [refetch]);

  return {
    shares: (query.data ?? []) as PortfolioShare[],
    loading: query.isFetching,
    error: query.error
      ? query.error instanceof Error
        ? query.error.message
        : 'Failed to load sharing status'
      : null,
    refresh,
  };
}
